export default {
      id: "log-in-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#log-in",
      toString: function () {
        return this.url;
      }
    }